import { ContextDSTheme } from '@design-system/contexts/ContextDSTheme'
import { dsThemes } from '@design-system/styles/themes'
import type { DSTheme } from '@design-system/styles/themes/types'
import { useContext } from 'react'

/**
 * Retrieve the theme tokens from the context.
 */
export function useDSTheme(): DSTheme {
  const { themeName } = useContext(ContextDSTheme)

  return {
    dsTheme: themeName,
    ...dsThemes[themeName]
  }
}
